import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterRenbukan extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterSunday1'>
      <div><Link to='/'>Home</Link></div>
      <h3>Member's Names</h3>
      <br />
      <br />

        <div><Link to='/conduct-danaiy'>1. AAT 0580  GEN.DANAI  YUWABOON(A)</Link></div>
        <br />
        <div><Link to='/conduct-kanina'>2. AAT 0747  MR.KANIN  AMPAIPAN(A)</Link></div>
        <br />
        <div><Link to='/conduct-natthaphati'>3. AAT 1402  MR.NATTHAPHAT INGSAKULSOMBOON(A)</Link></div>
        <br />
        <div><Link to='/conduct-worapotb'>4. AAT 2712  MR.WORAPOT  BENJANART(A)</Link></div>
        <br />
        <div><Link to='/conduct-somchaic'>5. AAT 3597  MR.SOMCHAI  CHAIYACHETDUMRONGKUL(A)</Link></div>
        <br />
        <div><Link to='/conduct-pisutk'>6. AAT 3814  MR.PISUT  KRIANGBURAPA(A)</Link></div>
        <br />
        <div><Link to='/conduct-michion'>7. AAT 4201  MR.MICHIO  NISHINARITA(A)</Link></div>
        <br />
        <div><Link to='/conduct-winyuc'>8. AAT 4360  MR.WINYU  CHAIYAWAN(A)</Link></div>
        <br />
        <div><Link to='/conduct-chaiwatt'>9. AAT 5081 MR.CHAIWAT  THIRAPANTU(A)</Link></div>
        <br />
        <div><Link to='/conduct-alexanderk'>10. AAT 5623  MR.ALEXANDER  KUSHNAREV(A)</Link></div>
        <br />
        <div><Link to='/conduct-ericc'>11. AAT 6712  MR.ERIC  CORNILE(A)</Link></div>
        <br />
        <div><Link to='/conduct-shintarok'>12. AAT 7764  MR.SHINTARO  KON(A)</Link></div>
        <br />
        <div><Link to='/conduct-carolync'>13. AAT 7839  MS.CAROLYN  COWAN(A)</Link></div>
        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterRenbukan;
